<!-- Produtos (painel compartilhado com a Cotação) -->
<app-ced-produtos
  [products]="products"
  [avisoAlteracao]="avisoAlteracaoProduto"
  (productsChange)="products = $event; productsChange.emit($event)"
  (dirty)="dirty.emit()">
</app-ced-produtos>

<!-- Fornecedores a cotar -->
<div class="section-title">
  <mat-icon>storefront</mat-icon>
  <span>Fornecedores</span>
  <span class="status-badge badge-cinza">{{ fornecedores.length }}</span>
  <div class="section-title-actions ms-auto">
    @if (!fornecedorAdding) {
      <span [matTooltip]="idCompra ? '' : 'Disponível depois de salvar o card'">
        <button mat-button type="button" class="btn-section" [disabled]="!idCompra" (click)="toggleAddingFornecedor()">
          <mat-icon>add</mat-icon>
          Adicionar fornecedor
        </button>
      </span>
    } @else {
      <button mat-button type="button" class="btn-section btn-section--cancel" (click)="toggleAddingFornecedor()">
        <mat-icon>close</mat-icon>
        Cancelar
      </button>
    }
  </div>
</div>

@if (fornecedorAdding) {
  <div class="ced-cot-add">
    <div class="ced-cot-add__head">
      <mat-icon class="material-symbols-outlined">person_add</mat-icon>
      <span>Adicionar fornecedor para cotar</span>
      <span class="ced-section-spacer"></span>
      <button type="button" class="ced-cot-add__close" (click)="toggleAddingFornecedor()" matTooltip="Fechar">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
    <div class="ced-cot-add__body">
      <app-select-pesquisavel
        [control]="fornecedorControl"
        [apiUrl]="urlFornecedor"
        [disabled]="fornecedorAdicionando"
        label="Fornecedor"
        idField="id"
        nameField="descricao"
        subscriptSizing="dynamic"
        (selectionChange)="addFornecedor($event)">
      </app-select-pesquisavel>
      <div class="ced-cot-add__hint">
        <mat-icon class="material-symbols-outlined">info</mat-icon>
        O fornecedor é gravado na hora e já aparece na etapa de Cotação. Condição de pagamento e envio da cotação são feitos lá.
      </div>
    </div>
  </div>
}

<div class="ced-cot-suppliers">
  @for (s of fornecedores; track s.id) {
    <div class="ced-cot-row">
      <div class="ced-cot-row__main">
        <div class="ced-cot-row__info">
          <div class="ced-cot-row__name">{{ s.name }}</div>
          <div class="ced-cot-row__when">{{ s.when }}</div>
        </div>
        <span class="status-badge"
          [class.badge-verde]="s.status === 'recebida'"
          [class.badge-amarelo]="s.status !== 'recebida' && s.enviada"
          [class.badge-cinza]="s.status !== 'recebida' && !s.enviada">
          <mat-icon class="material-symbols-outlined">{{ s.status === 'recebida' ? 'check_circle' : (s.enviada ? 'schedule' : 'mail') }}</mat-icon>
          {{ s.status === 'recebida' ? 'Proposta recebida' : (s.enviada ? 'Aguardando resposta' : 'Não enviada') }}
        </span>
        <button type="button" mat-icon-button class="ced-cot-row__remove"
          (click)="removeFornecedor(s)"
          matTooltip="Remover fornecedor">
          <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button>
      </div>
    </div>
  }
</div>

<!-- Justificativa -->
<div class="section-title">
  <mat-icon>edit_note</mat-icon>
  <span>Justificativa</span>
</div>
<div class="ced-field">
  <mat-form-field appearance="outline" class="ced-form-field">
    <mat-label>Justificativa de criação</mat-label>
    <textarea matInput rows="3" [ngModel]="justificativa" (ngModelChange)="justificativa = $event; justificativaChange.emit($event); dirty.emit()" [required]="justificativaObrigatoria" placeholder="Descreva o motivo da solicitação…"></textarea>
  </mat-form-field>
</div>
